import { Cancel, DoubleCheck, RefreshCircular } from 'iconoir-react';
import React, { useState, useEffect } from 'react'
import Button from '../Button'
import DropDownIcons from '../dropdowns/DropDownIcons';

const VerificationModal = ({onCancel, onSubmit, currentStatus}) => {
  const [details, setDetails] = useState({status: '', verification_comment: ''});

  console.log('action:: ', currentStatus);

  useEffect(() => {
    if(currentStatus.toLowerCase() === 'pending'){
      setDetails({...details, status: {label: 'PENDING', icon: <RefreshCircular className='text-yellow-700' />}});   
    }else if(currentStatus.toLowerCase() === 'rejected'){
      setDetails({...details, status: {label: 'REJECTED', icon: <Cancel className='text-red-600' />}});   
    }else{
      setDetails({...details, status: {label: 'APPROVED', icon: <DoubleCheck className='text-green-700' />}});   
    }
    // eslint-disable-next-line
  }, [currentStatus])  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({...details, [name]:value});
  }

  return (
    <div className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>User Verification</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <div className='my-5'>
            <DropDownIcons 
              onSelect={(item)=>{
                setDetails({...details, status: item})
              }}            
              selectedItem={details.status}  
              dropdownItems={[
                {icon: <RefreshCircular className='text-yellow-700' />, label: 'Pending'},
                {icon: <DoubleCheck className='text-green-700' />, label: 'Approved'},
                {icon: <Cancel className='text-red-600' />, label: 'Rejected'},
              ]} 
            />
          </div>
          <label className="block col-span-3 text-sm">
            <span className="text-gray-500 dark:text-gray-400">Enter comment if any</span>
            <textarea
              rows="3"
              required
              className="block w-full border px-3 text-gray-600 py-2 rounded mt-1 text-sm border-gray-400 dark:bg-gray-700 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
              placeholder="Verification comment"
              name="verification_comment"
              value={details.verification_comment}
              onChange={handleInputChange}
            />
          </label>
          <br />
          <br />
          <Button
            label={'Submit'}
            width="w-full"
            onClick={()=>onSubmit(details)}
            bgColor={'wayrideBgColor'}
          />
        </div>
      </div>
    </div>
  )
}

export default VerificationModal